import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';

export default function ConfirmModal({ 
    isOpen, 
    onClose, 
    onConfirm, 
    title, 
    message, 
    confirmText, 
    cancelText,
    isDanger = true,
    isLoading = false,
    children
}) {
    const { t } = useTranslation();

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Escape' && !isLoading) {
                onClose();
            }
        };

        if (isOpen) {
            window.addEventListener('keydown', handleKeyDown);
        }

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [isOpen, isLoading, onClose]);

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6">
            <div className="absolute inset-0 bg-slate-900/10"></div>

            <div className="relative w-full max-w-md overflow-hidden bg-white dark:bg-slate-800 rounded-2xl shadow-xl flex flex-col animate-in fade-in zoom-in duration-200">
                <div className="p-6">
                    <h2 className="text-xl font-bold text-slate-900 dark:text-white mb-2">
                        {title || t('common.confirm_title', 'Confirmar acción')}
                    </h2>
                    <p className="text-slate-600 dark:text-slate-400">
                        {message}
                    </p>
                    {children && <div className="mt-4">{children}</div>}
                </div>

                <div className="px-6 py-4 bg-slate-50 dark:bg-slate-700/50 border-t border-slate-100 dark:border-slate-700 flex justify-end gap-3">
                    <button
                        onClick={onClose}
                        disabled={isLoading}
                        className="px-4 py-2 text-sm font-medium text-slate-700 dark:text-slate-300 bg-white dark:bg-slate-800 border border-slate-300 dark:border-slate-600 rounded-full hover:bg-slate-50 dark:hover:bg-slate-700 focus:outline-none focus:ring-2 focus:ring-slate-200 dark:focus:ring-slate-700 disabled:opacity-50 transition-colors"
                    >
                        {cancelText || t('common.cancel', 'Cancelar')}
                    </button>
                    <button
                        onClick={onConfirm}
                        disabled={isLoading}
                        className={`px-4 py-2 text-sm font-medium text-white rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 dark:focus:ring-offset-slate-800 disabled:opacity-50 transition-colors ${
                            isDanger 
                                ? 'bg-red-600 hover:bg-red-700 focus:ring-red-500' 
                                : 'bg-primary-600 hover:bg-primary-700 focus:ring-primary-500'
                        }`}
                    >
                        {isLoading ? (
                            <div className="w-5 h-5 border-2 border-white/20 border-t-white rounded-full animate-spin"></div>
                        ) : (
                            confirmText || t('common.accept', 'Aceptar')
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
}
